import { Injectable } from '@angular/core';
import { Action } from '../model/action';
import { Drug } from '../model/drug';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';


@Injectable()
export class DrugServiceService {

  http:HttpClientService;
  cookie : CookiesService;
  objAction : Action;
  data : Drug;
  constructor(http : HttpClientService, cook : CookiesService) {
    this.http = http;
    this.cookie = cook;
    this.objAction  = new Action(this.http,  this.cookie);
  }
  
saveDrug() : Observable<Drug> {   
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = 'api/Drugs/CreateDrugs'
    return this.objAction.save();
 }
 updateDrug() : Observable<Drug> {   
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = 'api/Drugs/UpdateDrugs'
    return this.objAction.update();
 }
 getDrugs() : Observable<Drug[]> {   
    this.objAction.path = 'api/Drugs/GetDrugs'
    return this.objAction.get();
 }
 GetDrugsByGeneric(type: string, text: string) : Observable<Drug[]> {   
  this.objAction.path = 'api/Drugs/GetDrugsByGeneric?type='+ type + '&text='+text;
  return this.objAction.get();
}
 deleteDrug(objAction : Drug) : Observable<Drug> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = 'api/Drugs/DeleteDrugs?strDrugsId=' + objAction.DrugsId; 
    return this.objAction.delete();
 }

}



// WEBPACK FOOTER //
// ./src/app/section/master/services/drug-service.service.ts